const Header = () => {
    return (
      <header>
        <div className="header">
          <div>
            <img src="./help.svg" alt="help" />
          </div>
          <div>
            <span>WORDLE</span>
          </div>
          <div>
            <img src="./settings.svg" alt="settings" width="24px" />
          </div>
        </div>
      </header>
    );
};

export default Header;